import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as enums from '../enums'

export const DOC = gql`
  fragment FragmentSpaceRecordFunctionalUsage on SpaceRecordFunctionalUsage {
    functionalizationMethodology
    functionalizations {
      functionId
      percent
    }
    serviceCenterId
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceRecordFunctionalUsageFragment,
  ents.extra.space.Record.FunctionalUsage
>({
  functionalizationMethodology: graphql.transformers.OUT.nonNull(
    enums.SPACE_RECORD_FUNCTIONAL_METHODOLOGY,
  ),
  functionalizations: graphql.transformers.OUT.nullable(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.nonNull(
        graphql.transformers.OUT.object({
          functionId: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            ents.extra.space.Function.Id.isId,
          ),
          percent: transformers.PASS_THROUGH,
        }),
      ),
    ),
  ),
  serviceCenterId: graphql.transformers.OUT.nullable(
    graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      ents.extra.space.ServiceCenter.Id.isId,
    ),
  ),
})
